var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './Tab.css';
var Tab = function (_Component) {
  _inherits(Tab, _Component);
  function Tab(props) {
    _classCallCheck(this, Tab);
    var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this, props));
    _this.state = {
      activeIndex: _this.props.defaultActiveIndex
    };
    return _this;
  }
  _createClass(Tab, [{
    key: 'handleTabChange',
    value: function handleTabChange(e, index) {
      e.preventDefault();
      this.props.onTabChange(index);
      this.setState({
        activeIndex: index
      });
    }
  }, {
    key: 'getClasses',
    value: function getClasses() {
      return getBEMClasses(['ap-tab', this.props.customClass]);
    }
  }, {
    key: '_renderMenu',
    value: function _renderMenu() {
      var classes = this.getClasses();
      return React.createElement('div', {
        className: classes('menu', this.props.classModifiers)
      }, this._renderMenuItems());
    }
  }, {
    key: '_renderMenuItems',
    value: function _renderMenuItems() {
      var _this2 = this;
      var _props = this.props,
        panes = _props.panes,
        classModifiers = _props.classModifiers;
      var classes = this.getClasses();
      return panes.map(function (pane, index) {
        var activeClassName = _this2.state.activeIndex === index ? classes('menu-item', ['active'].concat(classModifiers.map(function (i) {
          return i + '-active';
        }))) : '';
        return React.createElement('div', {
          className: classnames(activeClassName, classes('menu-item', classModifiers)),
          onClick: function onClick(e) {
            if (pane.onSelect) {
              pane.onSelect();
            }
            _this2.handleTabChange(e, index);
          },
          key: pane.menuItem,
          'data-test': pane.menuItem
        }, _this2.context.t(pane.menuItem));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
        panes = _props2.panes,
        classModifiers = _props2.classModifiers;
      var currentPane = panes[this.state.activeIndex];
      var classes = this.getClasses();
      return React.createElement('div', {
        className: '' + classes('tab', classModifiers)
      }, this._renderMenu(), React.createElement('div', {
        className: classes('tab-content', classModifiers)
      }, currentPane.render()));
    }
  }]);
  return Tab;
}(Component);
Tab.propTypes = {
  onTabChange: PropTypes.func,
  panes: PropTypes.arrayOf(PropTypes.shape({
    menuItem: PropTypes.string.isRequired,
    render: PropTypes.func.isRequired,
    onSelect: PropTypes.func
  })).isRequired,
  customClass: PropTypes.string,
  classModifiers: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  defaultActiveIndex: PropTypes.number
};
Tab.defaultProps = {
  customClass: 'custom-tab',
  classModifiers: [],
  defaultActiveIndex: 0,
  onTabChange: function onTabChange() {}
};
Tab.contextTypes = {
  t: PropTypes.func.isRequired
};
export default Tab;